/** Toggle filter bar for selecting which question types to include in a revision session. */
import { TagButton } from '@/interfaces/learner/ui';
import { QUESTION_TYPE_META } from './questionTypes';

interface QuestionTypeFilterProps {
  selectedTypes: Set<string>;
  availableTypes: Set<string>;
  typeCounts: Map<string, number>;
  onToggle: (type: string) => void;
}

export default function QuestionTypeFilter({
  selectedTypes,
  availableTypes,
  typeCounts,
  onToggle,
}: QuestionTypeFilterProps) {
  return (
    <div>
      <p
        className="mb-2.5 font-semibold uppercase"
        style={{
          fontSize: 'var(--text-xs)',
          color: 'var(--color-text-muted)',
          letterSpacing: '0.08em',
        }}
      >
        Question Types
      </p>
      <div className="flex flex-wrap gap-2">
        {QUESTION_TYPE_META.filter((qt) => availableTypes.has(qt.value)).map((qt) => {
          const count = typeCounts.get(qt.value) ?? 0;
          const isSelected = selectedTypes.has(qt.value);
          const isLastSelected = isSelected && selectedTypes.size === 1;
          const Icon = qt.icon;

          return (
            <TagButton
              key={qt.value}
              size="md"
              tone={isSelected ? 'accent' : 'neutral'}
              variant={isSelected ? 'solid' : 'outline'}
              icon={<Icon size={14} />}
              count={count > 0 ? count : undefined}
              isDisabled={isLastSelected}
              onPress={() => onToggle(qt.value)}
            >
              {qt.shortLabel}
            </TagButton>
          );
        })}
      </div>
    </div>
  );
}
